<template>
    <div class="x-field">
        <div class="x-select">
            <!--            <div class="x-label-container">-->
            <label class="x-label" v-if="label">
                {{ label }}
                <slot name="label"></slot>
                <el-tooltip :content="tooltipContent"
                            effect="dark"
                            style="padding-left: 3px"
                            placement="top-end"
                            v-if="!!tooltipContent">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </label>
            <!--            </div>-->
            <div style="display: flex">
                <el-select :value="value"
                           :disabled="disabled"
                           :filterable="filterable"
                           :clearable="clearable"
                           :placeholder="placeholder"
                           :multiple="multiple"
                           :multiple-limit="multipleLimit"
                           @input="handleInput($event)"
                           :class="{'with-button-new': showButtonNew}">
                    <el-option v-for="option in options" :key="option[optionValue]" :value="option[optionValue]"
                               :label="option[optionLabel]"></el-option>
                </el-select>
                <x-button-icon icon="fal fa-plus"
                               type="primary"
                               @click="$emit('click-new')"
                               v-if="showButtonNew"></x-button-icon>
            </div>
            <small v-if="!!error" class="x-label-error" v-text="error"></small>
        </div>

    </div>
</template>

<script>
import XButtonIcon from "./XButtonIcon.vue";

export default {
    name: 'XSelect',
    components: {XButtonIcon},
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            default: ''
        },
        placeholder: {
            default: 'Seleccionar'
        },
        options: {
            default: []
        },
        optionValue: {
            type: String,
            default: 'id'
        },
        optionLabel: {
            type: String,
            default: 'name'
        },
        inputClass: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        filterable: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        multipleLimit: {
            type: Number,
            default: null
        },
        showButtonNew: {
            type: Boolean,
            default: false
        },
        error: {
            default: null,
        }
    },
    data() {
        return {}
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
    }
}
</script>
